import "./App.css";
import "./assets/css/style.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastContextProvider } from "./context/ToastContext";
import CombineRoutes from "routes/CombineRoutes";
import "react-phone-input-2/lib/style.css";
import { StrictMode, useEffect } from "react";

//run build for test
function App() {
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']") || document.createElement("link");
    favicon.rel = "icon";
    favicon.href = "/images/favicon.png";
    document.head.appendChild(favicon);
  }, []);
  return (
    <StrictMode>
      <BrowserRouter>
        <ToastContextProvider>
          <AuthProvider>
            <CombineRoutes />
          </AuthProvider>
        </ToastContextProvider>
      </BrowserRouter>
    </StrictMode>
  );
}

export default App;
